<div aria-label="Suche" role="region" class="container-fluid">
  @if (libConfig.showHeader) {
    <now-wbsuche-lib-responsive-context-info-header
      nowWbsucheLibScrollToAndFocus
      [shouldScroll]="scrollToHeader$"
      [shouldFocus]="scrollToHeader$"
    ></now-wbsuche-lib-responsive-context-info-header>
  }
  <now-wbsuche-lib-suchleiste
    [sucheMitBildungszielen]="libConfig.sucheMitBildungszielen"
    [bildungsziele]="bildungsziele"
    (dataChange)="triggerSearch()"
    [textSucheInputElementId]="textSucheInputElementId"
  ></now-wbsuche-lib-suchleiste>
  @if (mobile$ | async) {
    @if ((pageInfos$ | async)!.totalResults > 0 && (showRequiredInputState$ | async) !== true) {
      <div class="mb-2">
        <now-wbsuche-lib-suchergebnis-hits-card></now-wbsuche-lib-suchergebnis-hits-card>
      </div>
    }
  }

  @if ((showRequiredInputState$ | async) === false) {
    <now-wbsuche-lib-facetten [postleitzahl]="postleitzahl"></now-wbsuche-lib-facetten>
  }

  <div role="presentation">
    <now-wbsuche-lib-suchergebnis
      (terminSelected)="zeigeDetailseite.emit($event)"
    ></now-wbsuche-lib-suchergebnis>
    @if (showBildungsbereichAendernCard$ | async) {
      <hr />
      <now-wbsuche-lib-bildungsbereich-aendern-card
        [afterChangeFocusElementId]="'typeahead-' + textSucheInputElementId"
      ></now-wbsuche-lib-bildungsbereich-aendern-card>
    }
    <hr />
    @if (libConfig.showFeedbackComponent) {
      <now-wbsuche-lib-feedback></now-wbsuche-lib-feedback>
    }
  </div>
</div>
